export class LicitacaoFilter {
    numeroDaLicitacao: string = undefined;
    numeroContrato: string = undefined;
    modalidade: string = undefined;
    comissao: string = undefined;
    orgao: string = undefined;
    objetoDaLicitacao: string = undefined;
    dataInicio: Date = undefined;
    dataFim: Date = undefined;
    tipoDeDocumento: string = undefined;
    faseDaLicitacao: string = undefined;
    tipoDeObjetoDaLicitacao: string = undefined;
    palavraChave: string = undefined;
    identificador: string = undefined;
    isCovid19: boolean = undefined;
}



// WEBPACK FOOTER //
// ./src/app/_classes/licitacaoFilter.ts